import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-platform-tab-group',
  templateUrl: './platform-tab-group.component.html',
  styleUrls: ['./platform-tab-group.component.scss'],
})
export class PlatformTabGroupComponent implements OnInit {
  constructor(
    private api: ProductApiService,
    private message: MessageService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.findPlatformCategories();
  }
  index = 0;
  subIndex = 0;

  onIndexChange(i: number) {
    if(!parseInt(this.route.snapshot.queryParams['ii']))this.subIndex = 0;
    this.index = i;
  }

  onSubIndexChange(i: number) {
    this.subIndex = i;
  }

  categories: any[] = [];
  loading = false;
  async findPlatformCategories() {
    try {
      this.loading = true;
      const r = await this.api.findPlatformCategories();
      this.categories = r.data;
      this.index = parseInt(this.route.snapshot.queryParams['i']) || 0;
      this.subIndex = parseInt(this.route.snapshot.queryParams['ii']) || 0;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
